import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-stepper-button-row',
  templateUrl: './stepper-button-row.component.html',
  styleUrls: ['./stepper-button-row.component.scss']
})
export class StepperButtonRowComponent {
  @Input() isStart = false;
  @Input() isEnd = false;

  @Output() onNext = new EventEmitter<void>();
  @Output() onSubmit = new EventEmitter<void>();
  @Input() submitButtonLabel: string = 'Abschicken';

  next() {
    this.onNext.emit();
  }
  submit() {
    this.onSubmit.emit();
  }
}
